function onLoad() {
  $.fn.clicktoggle = function(a, b) {
    return this.each(function() {
      var clicked = false;
      $(this).click(function() {
        if (clicked) {
          clicked = false;
          return b.apply(this, arguments);
        }
        clicked = true;
        return a.apply(this, arguments);
      });
    });
  };
  //1
  $(".showdetails").clicktoggle(
    function() {
      $(this)
        //.html("<strong> ...less</strong>")
        .siblings(".details")
        .show();
      $(".showdetails").css("display", "none");
    }

    /*
      ,
      function() {
        $(this)
          .html("<strong>more...</strong>")
          .siblings(".details")
          .hide();
      }
      */
  );
}
module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/moredetails.js